import { storeToRefs } from "pinia";
import { useTimelineMapsStore } from "../stores/useTimelineMapsStore";

/** Use the session map index. Read the maps only when this project has none yet. */
export function useStoryboardMapLocations(): ReturnType<
  typeof storeToRefs<ReturnType<typeof useTimelineMapsStore>>
> {
  const store = useTimelineMapsStore();
  if (store.ready === false) void store.refresh();
  return storeToRefs(store);
}
